export enum FreePluginEnum {

    // TotalTiers, CampaignTypeID = 3, if user purchases > given amount -> receives free plugins
    TotalTiers = 3,

    // MultiPlugin, CampaignTypeID = 5, if user purchases > given number of products -> receives free plugins
    MultiPlugin = 5,
}